import script from "./healthQuestionnaireList.vue?vue&type=script&setup=true&lang=ts"
export * from "./healthQuestionnaireList.vue?vue&type=script&setup=true&lang=ts"

import "./healthQuestionnaireList.vue?vue&type=style&index=0&id=13e6e1f2&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e6e1f2"]])

export default __exports__